import { useTheme } from '@mui/material';

import { cardSurfaceSx } from '@sbv-clients/ui-shared';

export const useCardSx = () => {
  const theme = useTheme();
  return {
    ...cardSurfaceSx(theme),
    border: 'none',
    padding: '18px 20px',
  } as const;
};
